import { Agent } from '@models/agent.model';
import { CloudLabType } from '@modules/test-development/components/run-results/machine-config/cloud-lab-type';
import { HybridLabType } from '@modules/test-development/components/run-results/machine-config/hybrid-lab-type';
import { TestPlanLabType } from '@modules/test-development/enums/test-plan-lab-type.enum';

interface LabTypeProps {
  labType: TestPlanLabType;
  agent?: Agent;
  className?: string;
  variant?: 'detail' | 'concise';
  tooltipPlacement?: string;
  hideIcon?: boolean;
  externalAgentType?: string;
  externalAgentUrl?: string;
  tooltipClassName?: string;
}

export const LabType: React.FC<LabTypeProps> = ({
  labType,
  agent,
  className,
  variant = 'concise',
  tooltipPlacement = 'top',
  hideIcon,
  externalAgentType,
  externalAgentUrl,
  tooltipClassName,
}) => {
  const hybridLogoIcon =
    externalAgentType == 'SELENIUM' ? 'grid-logo' : 'hybrid-logo';
  const tooltipContent =
    externalAgentType == 'SELENIUM' ? externalAgentUrl : agent?.system?.title;
  if (labType == TestPlanLabType.Hybrid) {
    return (
      <HybridLabType
        agent={agent}
        iconName={hybridLogoIcon}
        className={className}
        variant={variant}
        tooltipPlacement={tooltipPlacement}
        hideIcon={hideIcon}
        tooltipContent={tooltipContent}
        externalAgentType={externalAgentType}
        tooltipClassName={tooltipClassName}
      />
    );
  }
  return (
    <CloudLabType
      labType={labType}
      className={className}
      variant={variant}
      tooltipPlacement={tooltipPlacement}
    />
  );
};
